'use client'

import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import { ChevronDown } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/routing'
import { N_FREE_ITEMS } from '@/config'
import '../../sass/landing/FaqV2.scss'

const FaqV2 = () => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: '-80px' })
  const t = useTranslations('LandingV2.faq')

  const questionIds = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10']

  return (
    <section id='faq' className='faq' ref={ref}>
      <div className='faq__container'>
        <motion.div
          className='faq__header'
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <span className='landing-v2__chip'>{t('chip')}</span>
          <h2>{t('heading')}</h2>
          <p>{t('description')}</p>
        </motion.div>

        <div className='faq__list'>
          {questionIds.map((id) => (
            <Accordion key={id} className='faq__item'>
              <AccordionSummary
                className='faq__summary'
                expandIcon={<ChevronDown size={18} />}
                aria-controls={`faq-${id}-content`}
                id={`faq-${id}-header`}
              >
                <p className='faq__question'>{t(`questions.${id}.question`)}</p>
              </AccordionSummary>
              <AccordionDetails className='faq__answer'>
                {id === 'q3'
                  ? t(`questions.${id}.answer`, { N_FREE_ITEMS })
                  : t(`questions.${id}.answer`)}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>

        <p className='faq__contact'>
          {t('contactPrefix')} <Link href='/support'>{t('contactLink')}</Link>
        </p>
      </div>
    </section>
  )
}

export default FaqV2
